export default __webpack_public_path__ + "static/media/casabassa.3aff4fae.jpg";